import React from "react";
import { Link, useLocation } from "react-router-dom";
import { QrCode, ShieldCheck, ShoppingBag } from "lucide-react";
import { useSettings } from "../context/SettingsContext";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";
import { imageUrl } from "../lib/api";

export default function SiteHeader() {
    const location = useLocation();
    const { settings } = useSettings();
    const { count } = useCart();
    const { user } = useAuth();
    const onCustomerProduct = location.pathname.startsWith("/p/");
    const onAdmin = location.pathname.startsWith("/admin");
    // Tombol Admin hanya muncul untuk user yang SUDAH login sebagai admin ATAU
    // saat sedang berada di halaman admin (biar mudah balik ke login). Public
    // visitor tidak melihat pintu masuk backend sama sekali.
    const showAdminButton = !!user || onAdmin;
    if (onCustomerProduct) return null;
    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-40 w-full border-b border-[hsl(var(--border))] bg-white/70 backdrop-blur-xl"
        >
            <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5">
                <Link to="/" data-testid="site-logo-link" className="flex items-center gap-2.5 group">
                    {settings.logo_path ? (
                        <img
                            src={imageUrl(settings.logo_path)}
                            alt={settings.name}
                            className="h-10 w-10 rounded-md object-contain bg-white border border-border"
                            data-testid="site-logo-image"
                        />
                    ) : (
                        <div className="grid h-9 w-9 place-items-center rounded-md bg-primary text-primary-foreground transition-transform group-hover:rotate-3">
                            <QrCode size={18} strokeWidth={1.75} />
                        </div>
                    )}
                    <div className="leading-tight">
                        <div className="font-heading font-semibold tracking-tight" data-testid="site-name">
                            {settings.name}
                        </div>
                        <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Katalog Toko</div>
                    </div>
                </Link>
                <nav className="flex items-center gap-2 text-sm">
                    {false && !onAdmin && (
                        <Link
                            to="/cart"
                            data-testid="nav-cart-link"
                            aria-label="Keranjang"
                            className="relative inline-flex h-9 w-9 items-center justify-center rounded-full border border-border bg-white hover:bg-secondary transition"
                        >
                            <ShoppingBag size={16} strokeWidth={1.75} />
                            {count > 0 && (
                                <span
                                    data-testid="cart-count-badge"
                                    className="absolute -top-1 -right-1 grid min-w-[18px] h-[18px] place-items-center rounded-full bg-accent px-1 text-[10px] font-bold text-accent-foreground"
                                >
                                    {count > 99 ? "99+" : count}
                                </span>
                            )}
                        </Link>
                    )}
                    <Link
                        to="/"
                        data-testid="nav-catalog-link"
                        className="rounded-full px-3 py-1.5 text-foreground/80 hover:bg-secondary hover:text-foreground transition-all duration-200"
                    >
                        Katalog
                    </Link>
                    {showAdminButton && (
                        <Link
                            to="/admin/login"
                            data-testid="nav-admin-link"
                            className="inline-flex items-center gap-1.5 rounded-full bg-primary px-3.5 py-1.5 text-primary-foreground hover:opacity-90 transition-all duration-200"
                        >
                            <ShieldCheck size={14} strokeWidth={1.75} />
                            Admin
                        </Link>
                    )}
                </nav>
            </div>
        </header>
    );
}
